module.exports = __webpack_public_path__ + "img/search_not.3e7116ae.png";